import React from 'react';
import { EyeOutlined, FlagOutlined, TeamOutlined } from '@ant-design/icons';
import { Card, Row, Col, Divider, Typography, Space } from 'antd';
import './AboutUs.css';
import ClientLogs from './ClientLogs';

const { Title, Text, Paragraph } = Typography;

const AboutUs = () => {
  const culturalValues = [
    {
      icon: <EyeOutlined style={{ fontSize: '24px' }} />,
      title: "Transparency",
      description: "Open communication in all we do"
    },
    {
      icon: <FlagOutlined style={{ fontSize: '24px' }} />,
      title: "Value Focus",
      description: "Business outcomes drive our solutions"
    },
    {
      icon: <TeamOutlined style={{ fontSize: '24px' }} />,
      title: "Collaboration",
      description: "Together we achieve more"
    }
  ];

  return (
    <div style={{
      background: 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)'
    }}>
      {/* Hero Section */}
      <div style={{
        padding: '4rem 1rem 2rem',
        textAlign: 'center',
        maxWidth: '1200px',
        margin: '0 auto'
      }}>
        <Space direction="vertical" size="large">
          <Title
            level={1}
            style={{
              fontSize: 'clamp(1.8rem, 5vw, 3.5rem)',
              fontWeight: 700,
              color: '#1a1a1a',
              marginBottom: 0
            }}
          >
            Who We Are
          </Title>
        </Space>
      </div>

      {/* Main Content */}
      <div style={{
        padding: '0 1rem 2rem',
        maxWidth: '1200px',
        margin: '0 auto'
      }}>
        {/* Description Card */}
        <Card
          bordered={false}
          style={{
            borderRadius: '16px',
            boxShadow: '0 4px 20px rgba(0, 0, 0, 0.08)',
            marginBottom: '2rem',
            transition: 'all 0.3s',
            border: '1px solid rgba(0, 0, 0, 0.05)'
          }}
          bodyStyle={{ padding: '1.5rem' }}
          hoverable
        >
          <Paragraph style={{
            fontSize: 'clamp(1rem, 2.5vw, 1.125rem)',
            color: '#434343',
            lineHeight: 1.6,
            marginBottom: 0,
            textAlign: 'center'
          }}>
            <span className='compTitle'>Shreshtech</span> delivers tailored IT solutions to established companies seeking custom software for growth.
            Combining modern technologies with transparent processes, we craft high-end web, mobile, and IoT solutions
            that drive business value.
          </Paragraph>
        </Card>

        {/* Cultural Code Section */}
        <div style={{ textAlign: 'center', marginBottom: '2rem' }}>
          <Title level={2} style={{ 
            color: '#1a1a1a', 
            marginBottom: '1rem',
            fontSize: 'clamp(1.5rem, 3vw, 2rem)'
          }}>
            Our Cultural Code
          </Title>
          <Divider style={{
            borderTop: '3px solid #722ed1',
            width: '80px',
            margin: '0 auto'
          }} />
        </div>

        {/* Values Grid */}
        <Row gutter={[16, 16]}>
          {culturalValues.map((value, index) => (
            <Col xs={24} sm={12} md={8} key={index}>
              <Card
                hoverable
                bordered={false}
                style={{
                  borderRadius: '12px',
                  boxShadow: '0 4px 12px rgba(0, 0, 0, 0.05)',
                  height: '100%',
                  transition: 'all 0.3s',
                  border: '1px solid rgba(0, 0, 0, 0.03)'
                }}
                bodyStyle={{
                  padding: '1.5rem',
                  textAlign: 'center'
                }}
              >
                <Space direction="vertical" size="middle">
                  <div style={{
                    width: '60px',
                    height: '60px',
                    margin: '0 auto',
                    background: 'linear-gradient(135deg, #e6f7ff 0%, #f6ffed 100%)',
                    borderRadius: '50%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                  }}>
                    {React.cloneElement(value.icon, {
                      style: {
                        color: '#1890ff',
                        fontSize: '24px'
                      }
                    })}
                  </div>

                  <Title level={3} style={{ 
                    marginBottom: '0.5rem', 
                    color: '#1a1a1a',
                    fontSize: '1.25rem'
                  }}>
                    {value.title}
                  </Title>

                  <Text style={{ 
                    color: '#595959', 
                    fontSize: '0.9rem',
                    display: 'block'
                  }}>
                    {value.description}
                  </Text>
                </Space>
              </Card>
            </Col>
          ))}
        </Row>

        <div style={{ textAlign: 'center', margin: '3rem 0 2rem' }}>
          <Title level={2} style={{ 
            color: '#1a1a1a', 
            marginBottom: '1rem',
            fontSize: 'clamp(1.5rem, 3vw, 2rem)'
          }}>
            Our Happy Clients
          </Title>
          <Divider style={{
            borderTop: '3px solid #722ed1',
            width: '80px',
            margin: '0 auto'
          }} />
        </div>

        <Row gutter={[16, 16]}>
          <ClientLogs />
        </Row>
      </div>

      {/* Bottom Accent */}
      <div style={{
        height: '4px',
        background: 'linear-gradient(90deg, #1890ff 0%, #722ed1 50%, #eb2f96 100%)'
      }} />
    </div>
  );
};

export default AboutUs;